import { useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';

const ForBackup: React.FC = () => {
    const { t } = useLang('landingPage.for_backup');

    const tabItems = [
        {
            title: t('a_title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747300858300/1.jpg',
            bottom: t('a_bottom'),
        },
        {
            title: t('b_title'),
            bottom: t('b_bottom'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747300858441/2.jpg',
        },
        {
            title: t('c_title'),
            bottom: t('c_bottom'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747300858657/3.jpg',
        },
        {
            title: t('d_title'),
            bottom: t('d_bottom'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747300858865/4.jpg',
        },
        {
            title: t('e_title'),
            bottom: t('e_bottom'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747300859121/5.jpg',
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className={styles.ForBackup}>
            <div className="desc">{t('desc')}</div>

            <div className="title">{t('title')}</div>

            <div className="tabs">
                <EcoImg pc={tabItems[activeIndex].pc} />
                <div className="tab-items">
                    {tabItems.map((item, index) => {
                        return (
                            <div className={'tab-item ' + (index === activeIndex ? 'active' : '')} key={index} onClick={() => setActiveIndex(index)}>
                                {item.title}
                            </div>
                        );
                    })}
                </div>
                <div className="footer-text">{tabItems[activeIndex].bottom}</div>
            </div>
        </div>
    );
};

export default ForBackup;
